<template>
  <div class="withdraw">
    <NavBtn
      :on-click="back"
    />
    <div class="title">提现</div>
    <div class="reward-info">
      <div class="wallet">
        <span>我的余额</span>
        <span>{{account_info.balance}}</span>
        <span>元</span>
        <div :class="[this.account_info.balance !== 0 ? 'btn-small' : 'btn-gray']"  @click="withdrawDeposit">提现</div>
      </div>
      <div class="sum">
        <span>累计奖励：</span>
        <span>{{account_info.total}}</span>
        <span>元</span>
      </div>
    </div>
    <div class="remind" v-if="withdraw_info.count">有 {{withdraw_info.count}} 笔提现正在处理中，总计 {{withdraw_info.amount}} 元，请耐心等待</div>
    <div style="margin-top: 40px;background: #3A4E92;">
      <div class="detail" v-for="(detail, index) in account_detail" :key="index">
      <div class="desc">{{detail.message}}</div>
      <div class="date">{{detail.created_at}}</div>
      <div class="num" :class="{'decrease': detail.amount < 0}">
        <span v-if="detail.amount > 0">+</span><span>{{detail.amount}}</span><span>元</span>
      </div>
    </div>
    </div>
    <ConfirmDialog />
    <WithdrawDialog ref="withdraw" :balanced='Number(account_info.balance)' @updateBalanced='updateBalanced'/>
  </div>
</template>
<style lang='scss' scoped>
  @media only screen and (device-height: 812px) {
    .withdraw{
      padding-top: 24px !important;
    }
  }
  .withdraw {
    background-color: #3A4E92;
    height: 100%;
    padding-top: 34px;

    .back {
      position: absolute;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .title {
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      margin-bottom: 30px;

      @include regular();
    }

    .reward-info {
      margin: 0 auto;
      box-shadow: 0 3px 5px 0 #2C2683;
      border-radius: 8px;
      background-color: #FFFFFF;
      width: 335px;
      height: 138px;
      padding-left: 15px;

      div:first-child {
        position: relative;
        height: 88px;
        border-bottom: 1px solid #EEEEEE;
        padding-top: 16px;

        .btn-gray {
          background:#e3e3e3;
          color:#fff;
          display: inline-block;
          width: 62px;
          height: 28px;
          line-height: 28px;
          border: 1px solid #e3e3e3;
          border-radius: 16px;
          font-size: 13px;
          text-align: center;
        }

        span:first-child {
          // position: absolute;
          // top: 16px;
          // left: 14px;
          // margin-left:14px;
          display: block;
          font-size: 13px;
          color: #3A3A3A;
          margin-bottom:5px;

          @include regular();
        }

        span:nth-child(2) {
          font-size: 32px;
          color: #3A3A3A;
          line-height: 38px;
          // margin-left:14px;
          margin-right:5px;
          // position: absolute;
          // top: 39px;
          // left: 15px;

          @include roboto();
        }

        span:nth-child(3) {
          // position: absolute;
          // top: 54px;
          // left: 70px;
          font-size: 13px;
          color: #3A3A3A;

          @include semibold();
        }

        div:last-child {
          position: absolute;
          top: 42px;
          right: 15px;
        }
      }

      div:nth-child(2) {
        height: 50px;
        line-height: 50px;

        span:first-child {
          font-size: 13px;
          color: #3A3A3A;

          @include regular();
        }

        span:nth-child(2) {
          font-size: 18px;
          color: #3A3A3A;
          position: relative;
          top: 1px;

          @include roboto();
        }

        span:nth-child(3) {
          font-size: 13px;
          color: #3A3A3A;

          @include semibold();
        }
      }
    }

    .remind {
      margin-top: 20px;
      font-size: 13px;
      color: #FFFFFF;
      text-align: center;

      @include regular();
    }

    .detail {
      margin: 0 auto;
      width: 335px;
      height: 70px;
      background-color: #FFFFFF;
      position: relative;
      margin-bottom: 10px;
      box-shadow: 0 3px 5px 0 #2C2683;
      border-radius: 8px;

      .desc {
        position: absolute;
        top: 16px;
        left: 15px;
        font-size: 13px;
        color: #3A3A3A;
        height: 18px;
        line-height: 18px;
        width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;

        @include regular();
      }

      .date {
        position: absolute;
        top: 36px;
        left: 15px;
        font-size: 13px;
        color: #B5B5B5;
        height: 18px;
        line-height: 18px;

        @include regular();
      }

      .num {
        position: absolute;
        top: 24px;
        right: 18px;
        color: #F75946;

        &.decrease {
          color: #3A3A3A;
        }

        span:first-child, span:nth-child(2) {
          font-size: 18px;

          @include roboto();
        }

        span:nth-child(2) {
          position: relative;
          top: 1px;
        }

        span:nth-child(3) {
          font-size: 13px;

          @include semibold();
        }
      }
    }
  }
</style>
<script>
  import WithdrawDialog from './WithdrawDialog'
  import ConfirmDialog from './ConfirmDialog'
  import { mapState, mapActions } from 'vuex'
  import { $toast } from '@/views/common/Loading.js'
  import { URI_USER_ACCOUNT } from '@/store/modules/account/type'
  export default {
    components: {
      WithdrawDialog,
      ConfirmDialog
    },
    data () {
      return { }
    },
    computed: {
      ...mapState({
        account_detail: state => state.account.account_detail,
        withdraw_info: state => state.account.withdraw_info,
        account_info: state => state.account.account_info,
        wechat_info: state => state.account.wechat_info,
        mobile: state => state.account.mobile
      })
    },
    mounted () {
      this.getAccountInfo()
    },
    methods: {
      ...mapActions({
        getAccountInfo: URI_USER_ACCOUNT
      }),

      withdrawDeposit () {
        if (this.account_info.balance !== 0) {
          if (!this.mobile) {
            $toast.show('请先绑定手机号码，跳转中...', 1500)
            return setTimeout(() => {
              this.$router.push('/bindMobile')
            }, 2000)
          }
          if (!this.wechat_info.wechat_realname) {
            $toast.show('请先绑定微信账号，跳转中...', 1500)
            return setTimeout(() => {
              this.$router.push('/BindWechat')
            }, 2000)
          }
          this.$refs.withdraw.show()
        }
      },

      updateBalanced (value) {
        this.account_info.balance = value
        this.getAccountInfo()
      },

      back () {
        this.$router.push('/dashboard')
      }
    }
  }
</script>
